<template>
  <div class="dashboard-content" id="MultipleContainers" v-if="!shouldRerender">
    <div>
      <div class="dashboard-content__col dashboard-content__col-1 StackedList" :data-col="1" v-if="dashboardWidgets">
        <div :class="registeredWidgets[item.component].hide || !checkStatWidgetSource(item) ? 'dashboard-content__col-item--hide' : null" class="dashboard-content__col-item StackedListItem--isDraggable" v-for="(item, index) of dashboardWidgets.col1" :key="index + '-' + item.id" :data-widget-type="item.component" :data-id="item.id">
          <keep-alive>
            <component :is="registeredWidgets[item.component].component" v-if="!registeredWidgets[item.component].hide && checkStatWidgetSource(item)" v-bind="{ ...item.props, disabled: registeredWidgets[item.component].disabled, editable: registeredWidgets[item.component].editable }" v-on="{ grabstart: () => { isDragging = true }, grabend: () => { isDragging = false }, delete: () => deleteWidget('col1', index), configure: () => editWidget(item) }"></component>
          </keep-alive>
        </div>
      </div>
    </div>
    <div>
      <div class="dashboard-content__col dashboard-content__col-2 StackedList" :data-col="2" v-if="dashboardWidgets">
        <div :class="registeredWidgets[item.component].hide || !checkStatWidgetSource(item) ? 'dashboard-content__col-item--hide' : null" class="dashboard-content__col-item StackedListItem--isDraggable" v-for="(item, index) of dashboardWidgets.col2" :key="index + '-' + item.id" :data-widget-type="item.component" :data-id="item.id" style="position: relative;">
          <keep-alive>
            <component :is="registeredWidgets[item.component].component" v-if="!registeredWidgets[item.component].hide && checkStatWidgetSource(item)" v-bind="{ ...item.props, disabled: registeredWidgets[item.component].disabled, editable: registeredWidgets[item.component].editable }" v-on="{ grabstart: () => { isDragging = true }, grabend: () => { isDragging = false }, delete: () => deleteWidget('col2', index), configure: () => editWidget(item) }"></component>
          </keep-alive>
        </div>
      </div>
    </div>
    <div>
      <div class="dashboard-content__col dashboard-content__col-3 StackedList" :data-col="3" v-if="dashboardWidgets">
        <div :class="registeredWidgets[item.component].hide || !checkStatWidgetSource(item) ? 'dashboard-content__col-item--hide' : null" class="dashboard-content__col-item StackedListItem--isDraggable" v-for="(item, index) of dashboardWidgets.col3" :key="index + '-' + item.id" :data-widget-type="item.component" :data-id="item.id">
          <keep-alive>
            <component :is="registeredWidgets[item.component].component" v-if="!registeredWidgets[item.component].hide && checkStatWidgetSource(item)"  v-bind="{ ...item.props, disabled: registeredWidgets[item.component].disabled, editable: registeredWidgets[item.component].editable }" v-on="{ grabstart: () => { isDragging = true }, grabend: () => { isDragging = false }, delete: () => deleteWidget('col3', index), configure: () => editWidget(item) }"></component>
          </keep-alive>
        </div>
      </div>
<!--      <div class="dashboard-content__add">-->

<!--      </div>-->
    </div>
  </div>
</template>

<script>
import AddWidget from '@/widgets/AddWidget'

import screen from '@/mixins/screen'
import { dashboardWidgets, editWidget } from '@/mixins/dashboardMixin'
import registeredWidgets from '@/widgets/registeredWidgets'
import { ShowGoldShopStatistics } from '@/mixins/displayRules'

const Classes = {
  draggable: 'StackedListItem--isDraggable',
  capacity: 'draggable-container-parent--capacity'
}

export default {
  mixins: [screen, dashboardWidgets, registeredWidgets, editWidget, ShowGoldShopStatistics],

  components: {
    AddWidget
  },

  data () {
    return {
      sortable: null,
      isDragging: false
    }
  },

  computed: {},

  methods: {
    checkStatWidgetSource (item) {
      if (!item) {
        return false
      }

      return !(item.component === 'SummaryWidget' && item.props && item.props.source === 'GOLDSHOP' && !this.ShowGoldShopStatistics)
    },

    async MultipleContainers () {
      // const { Sortable, Plugins } = await import('@shopify/draggable')
      const { Sortable } = await import('@shopify/draggable')
      const containers = document.querySelectorAll('#MultipleContainers .StackedList')

      if (containers.length === 0) {
        return false
      }

      const sortable = new Sortable(containers, {
        draggable: `.${Classes.draggable}`,
        mirror: {
          constrainDimensions: true
        }
        // plugins: [Plugins.ResizeMirror]
      })
      let lastOverContainer
      let isOverContainer = true

      // --- Draggable events --- //
      sortable.on('drag:start', (evt) => {
        if (!this.isDragging) {
          evt.cancel()
        }
      })

      sortable.on('drag:stop', () => {})

      sortable.on('sortable:sort', () => {})

      sortable.on('sortable:stop', () => {
        setTimeout(() => {
          if (isOverContainer) {
            // return
          }

          const newState = {
            col1: [],
            col2: [],
            col3: []
          }
          const el = document.getElementById('MultipleContainers')
          for (const node of el.childNodes) {
            for (const childEl of node.childNodes) {
              const col = childEl.dataset.col
              for (const childChildEl of childEl.childNodes) {
                if (newState['col' + col]) {
                  newState['col' + col].push(this.getWidgetById(childChildEl.dataset.id))
                }
              }
            }
          }

          this.updateWidgetsState(newState)
        }, 50)
      })

      sortable.on('sortable:sorted', (evt) => {
        if (lastOverContainer === evt.dragEvent.overContainer) {
          isOverContainer = true
          return
        }

        isOverContainer = false
        lastOverContainer = evt.dragEvent.overContainer
      })

      return sortable
    }
  },
  async mounted () {
    setTimeout(async () => {
      await this.MultipleContainers()
    }, 100)
    window.addEventListener('mouseup', () => {
      this.isDragging = false
    })
  },

  beforeDestroy () {
    window.removeEventListener('mouseup', () => {
      this.isDragging = false
    })
  }
}
</script>

<style lang="scss">
.dashboard-content {
  display: flex;
  justify-content: stretch;
  margin-left: -.6rem;
  //margin-right: -.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
  min-width: 98rem;
  overflow-x: auto;

  & > * {
    width: 100%;
    padding: 1rem;

    @include respond(tab-port) {
      width: 33.33%;
    }

    @include respond(tab-land) {
      width: 33.33%;
    }
  }

  &__col, &__add {
    padding-bottom: 4rem;

    &-item {
      margin-bottom: 1.5rem;

      &--hide {
        margin-bottom: 0;
      }
    }

    &-3 {
      padding-bottom: 2rem;
    }
  }
}

.StackedList {
  outline: none;
}

.StackedListItem--isDraggable {
  outline: none;
}

.draggable-mirror {
  & > * {
    transform: rotate(4.26deg);
  }
  z-index: 1;
}

.draggable-source--is-dragging {
  background-color: $color-azure-lighten;
  border-radius: 1rem;
  & > * {
    visibility: hidden;
  }

  .draggable--over {}
  .StackedListItem--dragging-active {}
}

.dashboard-content-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 4;
  top: 0;
  left: 0;
  background-color: $color-white;

  &__inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
</style>
